module.exports = __webpack_public_path__ + "static/yuanji-8aa4ca5229be72cde30936e0cf4abd70.png";